import FairsArchive from "./inc/FairsArchive";

// Launch when DOM is ready.
window.addEventListener('DOMContentLoaded', () => {
  new FairsArchive('.post-type-archive-trade_show');
});
